import type { ActionsObservable } from 'redux-observable';
import type { History } from 'history';
import { Observable } from 'rxjs/Observable';
import type { IssueScrollActions } from '@atlassian/jira-issue-scroll';
import {
	type ExternalScrollToCommentAction,
	SCROLL_TO_COMMENT,
} from '@atlassian/jira-issue-view-store/src/actions/external-actions';
import { getUrlPermalinkParameter, PermalinkType } from '@atlassian/jira-platform-issue-permalinks';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/empty';

export const scrollToCommentEpic =
	(issueScrollAction: IssueScrollActions, history: History) =>
	(action$: ActionsObservable<ExternalScrollToCommentAction>) =>
		action$.ofType(SCROLL_TO_COMMENT).mergeMap((action) => {
			history.push(
				getUrlPermalinkParameter(
					// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
					action.payload.commentId as string,
					PermalinkType.COMMENTS,
				),
			);
			issueScrollAction.setScrollTarget(null);

			return Observable.empty();
		});
